import { AlertCircle, CheckCircle2 } from "lucide-react";

export type Feedback = { kind: "success" | "error"; text: string } | null;

export function FormMessage({ feedback }: { feedback: Feedback }) {
  if (!feedback) return null;
  const isError = feedback.kind === "error";
  const Icon = isError ? AlertCircle : CheckCircle2;
  return (
    <div
      role={isError ? "alert" : "status"}
      className={
        "mb-3 flex items-start gap-2 rounded-md border px-3 py-2 text-xs " +
        (isError
          ? "border-destructive/40 bg-destructive/10 text-destructive"
          : "border-success/40 bg-success/10 text-success")
      }
    >
      <Icon className="mt-0.5 h-3.5 w-3.5 shrink-0" />
      <span className="min-w-0">{feedback.text}</span>
    </div>
  );
}
